import React from 'react';
import { connect } from 'react-redux';
import Client from '../Form/Form';
import AddClientWrapper from './AddClient.style';
import { setIcBoxUserToUpdate } from '../../../redux/actions/Client/ClientActions';

class AddClient extends React.Component {

  componentDidMount() {
    this.props.setIcBoxUserToUpdate({});
  }
  
  render() {
    return(
      <AddClientWrapper>
        <Client from='add' />
      </AddClientWrapper>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  setIcBoxUserToUpdate
};

export default connect(mapStateToProps, mapDispatchToProps)(AddClient);


// WEBPACK FOOTER //
// ./src/components/Client/AddClient/AddClient.js